export const BUSINESS_LINES = ['display-video', 'chatgpt-ads', 'geo'];
export const BUSINESS_LINE_LABELS = {
    'display-video': 'Display & Video',
    'chatgpt-ads': 'ChatGPT Ads',
    geo: 'GEO',
};
//# sourceMappingURL=revenue.js.map